import { NvButton } from '@simwood/nv-react-components';
import React from 'react';
import ContactImage from '../ContactImage';

import { handleEnterPress } from '../../helpers/util';
import * as styles from './styles.module.scss';
// FIXME

export interface Props {
  name: string;
  description?: string;
  email?: string;
  id?: string;
  type: string;
  status?: string;
  focussed?: boolean;
  disabled?: boolean;
  compact?: boolean;

  extraActions?: {
    id: string;
    name: string;
    icon: JSX.Element;
    kind?:
      | 'primary'
      | 'secondary'
      | 'danger'
      | 'warning'
      | 'success'
      | 'info'
      | 'neutral';
    onClick: (id: string) => void;
  }[];

  onClick?: () => void;
}

const Contact: React.FC<Props> = (props) => {
  const {
    name,
    description = '',
    email = '',
    id = '',
    type,
    status = '',
    focussed = false,
    disabled,
    compact,
    onClick,
    extraActions = [],
  } = props;

  const containerClass = styles.container;
  const focussedClass = focussed ? styles.focussed : '';
  const disabledClass = disabled ? styles.disabled : '';
  const liClass = `${containerClass} ${focussedClass} ${disabledClass}`;

  return (
    <li className={liClass}>
      <div
        className={styles.contact_row}
        onClick={onClick}
        onKeyDown={handleEnterPress(onClick)}
        role='button'
        tabIndex={0}
      >
        {!compact && (
          <ContactImage email={email} id={id} type={type} status={status} />
        )}
        <div
          className={[styles.info, compact ? styles.compact : '']
            .join(' ')
            .trim()}
        >
          <span title={name} className={styles.name}>
            {name}
          </span>
          <span title={description} className={styles.description}>
            {description}
          </span>
        </div>
        <div className={styles.actions}>
          {extraActions.map((action) => (
            <NvButton
              mini
              rounded
              size='small'
              className={styles.actionButton}
              key={action.id}
              kind={action.kind || 'primary'}
              onClick={(e) => {
                e.stopPropagation();
                action.onClick(id);
              }}
            >
              {action.icon}
            </NvButton>
          ))}
        </div>
      </div>
    </li>
  );
};

export default Contact;
